import Api from '../api'
export default ({

  state: {
    accountMasterLists: [],
    incomeAccountLists: [],
    expensesAccountLists: [],
    accountTypeLists: [],
    supplierAndCustomerList: [],
    supplierCustomerCashList: [],
    customerLists: [],
    customerFollowUpLists: [],
    supplierLists: [],
    FLists: [],
    cashLists: [],
    cashBankLists: [],
    transportationDetailsDetails: [],
    transportationDropDownLists: []
  },
  mutations: {
    ADD_ACCOUNT_MASTER(state, accountMaster) {
      let accountMasterList = state.accountMasterLists.concat(accountMaster)
      state.accountMasterLists = accountMasterList
    },
    ADD_SUPPLIER_ACCOUNT(state, supplier) {
      let supplierList = state.supplierLists.concat(supplier)
      state.supplierLists = supplierList
    },
    ADD_CUSTOMER_ACCOUNT(state, customer) {
      let customerList = state.customerLists.concat(customer)
      state.customerLists = customerList
    },
    ADD_EXPENSES_ACCOUNT(state, expense) {
      let expenses = state.expensesAccountLists.concat(expense)
      state.expensesAccountLists = expenses
    },
    ADD_TRANSPORTATION_DETAILS(state, expense) {
      let expenses = state.transportationDetailsDetails.concat(expense)
      state.transportationDetailsDetails = expenses
    },
    ADD_INCOME_ACCOUNT(state, income) {
      let incomes = state.incomeAccountLists.concat(income)
      state.incomeAccountLists = incomes
    },
    DELETE_ACCOUNT_MASTER(state, accountMasterId) {
      let accountMasterList = state.accountMasterLists.filter(a => a.id !== accountMasterId.id)
      state.accountMasterLists = accountMasterList
      let supplierList = state.supplierLists.filter(a => a.id !== accountMasterId.id)
      state.supplierLists = supplierList
      let customerLists = state.customerLists.filter(a => a.id !== accountMasterId.id)
      state.customerLists = customerLists
    },
    DELETE_EXPENSE_ACCOUNT(state, expenses) {
      let expenseList = state.expensesAccountLists.filter(expense => expense.id !== expenses.id)
      state.expensesAccountLists = expenseList
    },
    DELETE_TRANSPORTATION_DETAILS(state, expenses) {
      let expenseList = state.transportationDetailsDetails.filter(expense => expense.id !== expenses.id)
      state.transportationDetailsDetails = expenseList
    },
    DELETE_INCOME_MASTER(state, incomes) {
      let incomeList = state.incomeAccountLists.filter(income => income.id !== incomes.id)
      state.incomeAccountLists = incomeList
    },
    ADD_ACCOUNT_TYPE(state, accountTypeLists) {
      let accountTypeList = state.accountTypeLists.concat(accountTypeLists)
      state.accountTypeLists = accountTypeList
    },
    SET_ACCOUNT_MASTER_LIST(state, accountMasterList) {
      state.accountMasterLists = accountMasterList
    },
    SET_INCOME_ACCOUNT_MASTER_LIST(state, accountMasterList) {
      state.incomeAccountLists = accountMasterList
    },
    SET_EXPENSES_ACCOUNT_MASTER_LIST(state, accountMasterList) {
      state.expensesAccountLists = accountMasterList
    },
    SET_ACCOUNT_TYPE_LIST(state, accountTypeList) {
      state.accountTypeLists = accountTypeList
    },
    SET_SUPPLIER_CUSTOMER(state, supplierAndCustomerAccountList) {
      state.supplierAndCustomerList = supplierAndCustomerAccountList
    },
    SET_SUPPLIER_CUSTOMER_CASH(state, supplierCustomerCash) {
      state.supplierCustomerCashList = supplierCustomerCash
    },
    SET_TRANSPORTATION_DETAILS(state, transportationDropDownList) {
      state.transportationDropDownLists = transportationDropDownList
    },
    SET_BANK_LIST(state, bankList) {
      state.bankLists = bankList
    },
    SET_CASH_BANK_LIST(state, cashBankList) {
      state.cashBankLists = cashBankList
    },
    SET_CASH_LIST(state, cashList) {
      state.cashLists = cashList
    },
    SET_CUSTOMER_LIST(state, customerList) {
      state.customerLists = customerList
    },
    SET_CUSTOMER_FOLLOWUP_LIST(state, customerFollowUpList) {
      state.customerFollowUpLists = customerFollowUpList
    },
    SET_SUPPLIER_LIST(state, supplierList) {
      state.supplierLists = supplierList
    },
    SET_TRANSPORTATION_DETAILS_LIST(state, transportationDetailsDetail) {
      state.transportationDetailsDetails = transportationDetailsDetail
    },
    UPDATE_SUPPLIER(state, updatedSupplier) {
      state.supplierLists = state.supplierLists.map(supplier => supplier.id !== updatedSupplier.id ? supplier : {...supplier, ...updatedSupplier})
    },
    UPDATE_CUSTOMER(state, updatedCustomer) {
      state.customerLists = state.customerLists.map(customer => customer.id !== updatedCustomer.id ? customer : {...customer, ...updatedCustomer})
    },
    UPDATE_ACCOUNT_MASTER(state, updatedAccountMaster) {
      state.accountMasterLists = state.accountMasterLists.map(accMaster => accMaster.id !== updatedAccountMaster.id ? accMaster : {...accMaster, ...updatedAccountMaster})
    },
    UPDATE_EXPENSES_ACCOUNT(state, expensesAccount) {
      state.expensesAccountLists = state.expensesAccountLists.map(accMaster => accMaster.id !== expensesAccount.id ? accMaster : {...accMaster, ...expensesAccount})
    },
    UPDATE_INCOME_ACCOUNT(state, incomeAccount) {
      state.incomeAccountLists = state.incomeAccountLists.map(accMaster => accMaster.id !== incomeAccount.id ? accMaster : {...accMaster, ...incomeAccount})
    },
    SET_OFFICE_ACCOUNT(state, officeAccountList) {
      state.accountMasterLists = officeAccountList
    },
    UPDATE_TRANSPORTATION_DETAILS(state, incomeAccount) {
      state.transportationDetailsDetails = state.transportationDetailsDetails.map(accMaster => accMaster.id !== incomeAccount.id ? accMaster : {...accMaster, ...incomeAccount})
    }
  },
  actions: {

    async createAccountMaster({commit}, accountMaster) {
      let response = await Api.request('post', '/accountMaster/createAccountMaster/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', accountMaster)
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_ACCOUNT_MASTER', savedAccountMaster)
      }
      return response
    },
    async createExpensesAccount({commit}, expenses) {
      let response = await Api.request('post', '/accountMaster/createAccountMaster/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', expenses)
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_EXPENSES_ACCOUNT', savedAccountMaster)
      }
      return response
    },
    async createTransportation({commit}, expenses) {
      let response = await Api.request('post', '/transportationDetails/createTransportationDetails/' + this.state.organisationid + '/' + this.state.user.id, expenses)
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_TRANSPORTATION_DETAILS', savedAccountMaster)
      }
      return response
    },
    async deleteTransportation({commit}, deleteRea) {
      let response = await Api.request('delete', '/transportationDetails/deleteTransportationDetails/' + deleteRea.id + '/' + this.state.user.id + '/' + deleteRea.deleteReason)
      let purchaseSundary = response.data.data
      commit('DELETE_TRANSPORTATION_DETAILS', purchaseSundary)
      return response
    },
    async createIncomeAccount({commit}, income) {
      let response = await Api.request('post', '/accountMaster/createAccountMaster/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', income)
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_INCOME_ACCOUNT', savedAccountMaster)
      }
      return response
    },
    async deleteAccMaster({ commit }, accountMaster) {
      let resp = await Api.request('delete', '/accountMaster/deleteAccountMaster/' + accountMaster.accountMasterId + '/' + this.state.user.id + '/' + this.state.fyId + '/' + accountMaster.deleteReason)
      let deleteAccMasters = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_ACCOUNT_MASTER', deleteAccMasters)
      }
      return resp
    },
    async deleteExpenseAccount({ commit }, expenseAccount) {
      let resp = await Api.request('delete', '/accountMaster/deleteAccountMaster/' + expenseAccount.accountMasterId + '/' + this.state.user.id + '/' + this.state.fyId + '/' + expenseAccount.deleteReason)
      let deleteAccMasters = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_EXPENSE_ACCOUNT', deleteAccMasters)
      }
      return resp
    },
    async deleteIncomeMaster({ commit }, incomeAccount) {
      let resp = await Api.request('delete', '/accountMaster/deleteAccountMaster/' + incomeAccount.accountMasterId + '/' + this.state.user.id + '/' + this.state.fyId + '/' + incomeAccount.deleteReason)
      let deleteAccMasters = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_INCOME_MASTER', deleteAccMasters)
      }
      return resp
    },
    async createCustomerAccount({commit}, account) {
      let response = await Api.request('post', '/accountMaster/createCustomerAccount/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', account)
      let savedCustomer = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_CUSTOMER_ACCOUNT', savedCustomer)
      }
      return response
    },

    async createSupplierAccount({commit}, account) {
      let response = await Api.request('post', '/accountMaster/createSupplierAccount/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', account)
      let savedSupplier = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_SUPPLIER_ACCOUNT', savedSupplier)
      }
      return response
    },
    async loadAccountTypeList({ commit }) {
      let response = await Api.request('get', '/accountMaster/accountTypeList', null)
      commit('SET_ACCOUNT_TYPE_LIST', response.data.data)
    },
    async loadAccountMasterList({ commit }) {
      let response = await Api.request('get', '/accountMaster/accountMasterList/' + this.state.organisationid + '/' + this.state.fyId, null)
      commit('SET_ACCOUNT_MASTER_LIST', response.data.data)
      return response
    },
    async loadIncomeAccountList({ commit }) {
      let response = await Api.request('get', '/accountMaster/incomeMasterList/' + this.state.organisationid + '/' + this.state.fyId, null)
      commit('SET_INCOME_ACCOUNT_MASTER_LIST', response.data.data)
    },
    async loadExpensesAccountList({ commit }) {
      let response = await Api.request('get', '/accountMaster/expensesMasterList/' + this.state.organisationid +
        '/' + this.state.fyId, null)
      commit('SET_EXPENSES_ACCOUNT_MASTER_LIST', response.data.data)
    },
    async loadCustomerAccountList({ commit }) {
      let response = await Api.request('get', '/accountMaster/customerMasterList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_CUSTOMER_LIST', response.data.data)
      return response
    },
    async loadCustomerFollowUpAccountList({ commit }) {
      let response = await Api.request('get', '/accountMaster/customerMasterFollowUpList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_CUSTOMER_FOLLOWUP_LIST', response.data.data)
      return response
    },
    async loadSupplierAccountList({ commit }) {
      let response = await Api.request('get', '/accountMaster/supplierMasterList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_SUPPLIER_LIST', response.data.data)
      return response
    },
    async loadTransportationDropDownList({ commit }) {
      let response = await Api.request('get', '/transportationDetails/transportationDropDown/' + this.state.organisationid)
      commit('SET_TRANSPORTATION_DETAILS', response.data.data)
      return response
    },
    async loadTransportationDetailsList({ commit }) {
      let response = await Api.request('get', '/transportationDetails/transportationDetailsList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_TRANSPORTATION_DETAILS_LIST', response.data.data)
    },
    async loadsupplierAndCustomerList({commit}) {
      let response = await Api.request('get', '/accountMaster/supplierAndCustomerAccount/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_SUPPLIER_CUSTOMER', response.data.data)
      return response
    },
    async loadsupplierCustomerAndCashList({commit}) {
      let response = await Api.request('get', '/accountMaster/supplierCustomerCashAccount/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_SUPPLIER_CUSTOMER_CASH', response.data.data)
    },
    async updateSupplierAccount({commit}, supplier) {
      let response = await Api.request('put', '/accountMaster/' + supplier.id + '/' + 'supplierAcc/' + this.state.fyId, supplier)
      commit('UPDATE_SUPPLIER', response.data.data)
      return response
    },
    async updateCustomerAccount({commit}, customer) {
      let response = await Api.request('put', '/accountMaster/' + customer.id + '/' + 'customerAcc/' + this.state.fyId, customer)
      commit('UPDATE_CUSTOMER', response.data.data)
      return response
    },
    async updateAccountMaster({commit}, accountMaster) {
      let resp = await Api.request('put', '/accountMaster/' + accountMaster.id + '/' + 'office' + '/' + this.state.fyId, accountMaster)
      commit('UPDATE_ACCOUNT_MASTER', resp.data.data)
      return resp
    },
    async updateExpensesAccount({commit}, accountMaster) {
      let resp = await Api.request('put', '/accountMaster/' + accountMaster.id + '/' + 'office' + '/' + this.state.fyId, accountMaster)
      commit('UPDATE_EXPENSES_ACCOUNT', resp.data.data)
      return resp
    },
    async verifyCustomer({ commit }, accountMaster) {
      let resp = await Api.request('put', '/accountMaster/verifyCustomer/' + accountMaster.accountMasterId + '/' + accountMaster.verify + '/' + this.state.user.id + '')
      if (resp.data.status === 'SUCCESS') {
        commit('UPDATE_INCOME_ACCOUNT', resp.data.data)
      }
      return resp
    },
    async resetUserPassword({ commit }, accountMaster) {
      let resp = await Api.request('put', '/users/resetUserPassword/' + accountMaster.id + '')
      if (resp.data.status === 'SUCCESS') {
        commit('UPDATE_INCOME_ACCOUNT', resp.data.data)
      }
      return resp
    },
    async updateIncomeAccount({commit}, incomeAcc) {
      let resp = await Api.request('put', '/accountMaster/' + incomeAcc.id + '/' + 'office' + '/' + this.state.fyId, incomeAcc)
      if (resp.data.status === 'SUCCESS') {
        commit('UPDATE_INCOME_ACCOUNT', resp.data.data)
      }
      return resp
    },
    async updateTransportationDetails({commit}, transportation) {
      let resp = await Api.request('put', '/transportationDetails/transportationDetailsUpdate/' + transportation.id + '/' + this.state.organisationid + '/' + this.state.user.id, transportation)
      if (resp.data.status === 'SUCCESS') {
        commit('UPDATE_TRANSPORTATION_DETAILS', resp.data.data)
      }
      return resp
    },
    async loadOfficeAccountListForDropdown({commit}) {
      let response = await Api.request('get', '/accountMaster/accountMasterListForDropdown/' + this.state.organisationid + '/' + 'office' + '/' + this.state.user.id + '')
      commit('SET_OFFICE_ACCOUNT', response.data.data)
      return response
    },
    async loadCustomerSupplierListForDropdown({commit}) {
      let response = await Api.request('get', '/accountMaster/accountMasterListForDropdown/' + this.state.organisationid + '/' + 'inventory' + '/' + this.state.user.id + '')
      // commit('SET_SUPPLIER_CUSTOMER', response.data.data)
      return response
    },
    async loadBankList({commit}) {
      let response = await Api.request('get', '/accountMaster/bankListForDropdown/' + this.state.organisationid + '')
      commit('SET_BANK_LIST', response.data.data)
      return response
    },
    async loadCashAndBankList({commit}) {
      let response = await Api.request('get', '/accountMaster/cashAndBankListForDropdown/' + this.state.organisationid + '/' + this.state.user.id + '')
      commit('SET_CASH_BANK_LIST', response.data.data)
      return response
    },
    async loadCashListForDropdown({commit}) {
      let response = await Api.request('get', '/accountMaster/accountMasterListForDropdown/' + this.state.organisationid + '/' + 'cash' + '/' + this.state.user.id + '')
      commit('SET_CASH_LIST', response.data.data)
      return response
    },
    async loadSupplierByName({commit}, supplier) {
      let response = await Api.request('get', '/accountMaster/supplierByName/' + this.state.organisationid + '/' + supplier.name + '')
      return response
    },
    async updateFollowUpStatus({commit}, data) {
      let response = await Api.request('put', '/delivery/updateStatusByAdmin/' + data.id + '/' + data.statusType + '/' + data.reason + '')
      if (response.data.status === 'SUCCESS') {
        commit('DELIVERY_STATUS_UPDATE', response.data.data)
        return response
      }
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/accountMaster.js